import { hashStringToSeed, mulberry32 } from './seededRandom';

const SKINS = ['#ffdbac', '#f1c27d', '#e0ac69', '#c68642', '#8d5524'];
const HAIR_STYLES = ['bald', 'short', 'buzz', 'ponytail', 'afro'];
const HAIR_COLORS = ['#2b1b0e', '#4a2f1b', '#6b4423', '#1a1a1a', '#7a7a7a', '#b5651d'];

/**
 * Deterministic per-worker look derived from a stable id.
 * @param {string|number} id
 * @returns {{skin,hairStyle,hairColor,heightScale,build,hasBeard,hasGlasses,hasBackpack}}
 */
export function workerAppearance(id) {
  const rand = mulberry32(hashStringToSeed(id));
  const pick = (arr) => arr[Math.floor(rand() * arr.length)];
  return {
    skin: pick(SKINS),
    hairStyle: pick(HAIR_STYLES),
    hairColor: pick(HAIR_COLORS),
    heightScale: 0.9 + rand() * 0.2,
    build: 0.9 + rand() * 0.2,
    hasBeard: rand() < 0.4,
    hasGlasses: rand() < 0.3,
    hasBackpack: rand() < 0.35,
  };
}
